(()=>{
  'use strict';
  if(window.__bmVelgenadviesRuntime)return;
  window.__bmVelgenadviesRuntime=true;

  const roots=()=>[...document.querySelectorAll('[data-bm-va-vehicle]')];

  const labelVehicle=(vehicle)=>{
    if(!vehicle)return '';
    const api=window.BandenmeestersVehicle;
    if(api&&typeof api.vehicleLabel==='function')return api.vehicleLabel(vehicle);
    return [vehicle.brand&&vehicle.brand.name,vehicle.generation&&vehicle.generation.name||vehicle.model&&vehicle.model.name].filter(Boolean).join(' ');
  };

  const render=(vehicle)=>{
    roots().forEach((root)=>{
      const title=root.querySelector('[data-bm-va-vehicle-title]');
      const meta=root.querySelector('[data-bm-va-vehicle-meta]');
      const link=root.querySelector('[data-bm-va-vehicle-link]');
      const generation=vehicle&&vehicle.generation;
      const vehicleLabel=labelVehicle(vehicle);

      if(generation&&generation.url){
        if(title)title.textContent=vehicleLabel||'Jouw auto';
        if(meta)meta.textContent='Auto geselecteerd. Open de generatiepagina om voertuigspecifieke gegevens en gekoppelde voorraad te bekijken.';
        if(link){
          link.href=generation.url;
          link.innerHTML='Bekijk passende velgen <span aria-hidden="true">→</span>';
        }
      }else{
        if(title)title.textContent='Kies merk, model en generatie';
        if(meta)meta.textContent='De exacte generatie is belangrijk: dezelfde modelnaam kan verschillende steekmaten, remmen en toegestane wielmaten hebben.';
      }
    });
  };

  const current=()=>window.BandenmeestersVehicle&&typeof window.BandenmeestersVehicle.getActive==='function'
    ? window.BandenmeestersVehicle.getActive()
    : null;

  const boot=()=>render(current());
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();

  document.addEventListener('bm:vehicle:ready',(event)=>render(event.detail&&event.detail.vehicle||current()));
  window.addEventListener('bm:vehicle:change',(event)=>render(event.detail&&event.detail.vehicle||current()));
  window.addEventListener('pageshow',()=>render(current()));
})();